import { useTranslation } from 'react-i18next'
import React from 'react'

import Switch from './Switch'

const SelectAllSwitch = ({ value = [], onChange }) => {
  const { t } = useTranslation('common')
  const isAllSelected = value.includes('all')

  const handleChange = () => {
    onChange(isAllSelected ? [] : ['all'])
  }

  return <Switch label={t('selectAll')} onChange={handleChange} value={isAllSelected} noMargin />
}

export default SelectAllSwitch
